import React, { useEffect, useRef, useState } from "react";
import { actionDots, downloadReport, warningIcon } from "../../../assets/images";
import { Complaints, Consultation, EditHistory, SubmerchantModal, SupportDrawer, UiButton, UiRangePicker, UiSearch, UiSelect, UiTab, UiTable, UiTextArea } from "../../../components";
import { lang_en_US as translation } from "../../../config";
import "./style.scss"
import { actionDropdownMenu, APPROVAL_HEADER_COLUMNS, complaintAgainstDropdown, complaintesTabData, consultationTabData, EDIT_HISTORY_COLUMNS, LAWYER_EDITABLE_FIELDS, pendingConsultationDropdown, REJECTED_HEADER_COLUMNS, tabData } from "./config";
import { DatePicker, Dropdown, Menu, Modal, Space } from "antd";
import { searchInitiateDelayTime, tablePageSizeOptions, exportAdvocateReportToExcel } from "../../../utils/appUtils";
import ProfileView from "./profileView";
import * as api from "../../../actions";
import { ACCOUNT_DETAILS, COMPLAINTS, CONSULTATION, CUSTOMERMANAGEMENT, LAWYERMANAGEMENT, SENDMESSAGEWHATSAPP, SENDMESSAGEMAILID, SENDMESSAGEWHATSAPPSUPPORT, SENDMESSAGEMAILSUPPORT, SUPPORTMANAGEMENT } from "../../../apiServices/endpoints";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import AllLawyerReport from "./reports/allLawyerReport";
import { useReactToPrint } from "react-to-print";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { loaderReducer } from "../../../reducer/loader.reducer";
import LawyerDocuments from "./LawyerDocuments";
import BankDetailsModal from "./BankDetailsModal";
import { showErrorNotification, showSuccessNotification } from "../../../components/uiNotification";
import ConsultationView from "../../../components/consultation/consultationView";
import ComplaintView from "../../../components/consultation/complaintView";
import SingleComplaintReport from "../../../components/complaints/SingleComplaintreport";
import ComplaintReport from "../../../components/complaints/complaintReport";
import ConsultationReport from "../../../components/consultation/consultationReport";
import { messageTabData } from "../../../components/complaints/config";

const PrintAllLawyerReport = React.forwardRef((props, ref) => {
    return <div ref={ref}>
        <AllLawyerReport data={props?.data} fromDate={props?.fromDate} toDate={props?.toDate} activeTab={props?.activeTab} selectedMonth={props?.selectedMonth} selectedMonthString={props?.selectedMonthString} />
    </div>
});

const PrintSingleComplaintreport = React.forwardRef((props, ref) => {
    return <div ref={ref} >
        <SingleComplaintReport complaintIdData={props?.complaintIdData} />
    </div>
});

const PrintComplaintReport = React.forwardRef((props, ref) => {
    return <div ref={ref}>
        <ComplaintReport activeTab={props?.activeTab} data={props?.data} fromDate={props?.fromDate} toDate={props?.toDate} complaintStatus={props?.complaintStatus} selectedMonth={props?.selectedMonth} selectedMonthString={props?.selectedMonthString} />
    </div>
});

const PrintConsultationReport = React.forwardRef((props, ref) => {
    return <div ref={ref}>
        <ConsultationReport data={props?.data} activeTab={props?.activeTab} allConsultationData={props?.allConsultationData} consultation={props?.consultation} selectedMonth={props?.selectedMonth} selectedMonthString={props?.selectedMonthString} />
    </div>
});

const initialEditHistoryState = {
    editHistoryData: [],
    selectedLawyerName: "",
    selectedLawyerProfile: {},
    selectedHistoryDetail: null
};

const Lawyer = () => {
    const keywords = translation?.lawyerManagement;
    const reportRef = useRef(null);
    const complaintRef = useRef(null);
    const singlcomplaintRef = useRef(null);
    const consultationRef = useRef(null);
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const debounceTimeOut = useRef(null);
    const adminuserId = sessionStorage.getItem("userId");
    const configResults = useSelector((state) => state?.configAction?.configData);
    const activeStatus = configResults?.find((detail) => detail?.configId === "USER STATUS")?.configuration?.map((config) => ({ key: config, value: config }));
    const blockDaysOption = configResults?.find((detail) => detail?.configId === "BLOCKING_DAYS")?.configuration?.map((config) => ({ key: config, value: `${config} Days` }));
    const agreementConfig = configResults?.find((detail) => detail?.configId === "advocateuseragreement");
    const agreementMd = agreementConfig?.configuration?.[0] || agreementConfig?.defaultValue || "";
    const toemailaddress = configResults?.find((detail) => detail?.configId === "advLabelToAddress")?.configuration?.map((config) => ({ key: config, value: config }));
    const ccemailaddress = configResults?.find((detail) => detail?.configId === "advLabelCcAddress")?.configuration?.map((config) => ({ key: config, value: config }));


    const handlePrint = useReactToPrint({
        content: () => reportRef.current,
        onAfterPrint: () => setLawyerFilter(prev => ({ ...prev, size: 10, isReportOpen: false })),
        pageStyle: ` body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                }
                 .print-page::before {
                    content: "";
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    border: 2px solid #005D60;
                    z-index: 9999;
                    pointer-events: none;
                }`}
    );

    const handleComplaintReportPrint = useReactToPrint({
        content: () => singlcomplaintRef.current,
        onAfterPrint: () => {
            setComplaintFilters(prev => ({ ...prev, isComplaintReportOpen: false }))
            setComplaintIDData({ rasiedByProfile: "", againstByProfile: "", data: {} })
        },
        pageStyle: ` body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                }
                 .singleComplaintReport::before {
                    content: "";
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    border: 2px solid #005D60;
                    z-index: 9999;
                    pointer-events: none;
                }`
    });

    const handleAllComplaintReportPrint = useReactToPrint({
        content: () => complaintRef.current,
        onAfterPrint: () => {
            setComplaintFilters(prev => ({ ...prev, size: 10, isAllComplaintReportOpen: false }))
            setComplaintsResponseData({ lawyerResponse: {}, customerResponse: {}, lawyerProfile: "", complaintsData: [] })
        },
        pageStyle: `body {
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                        .complaint-report::before{
                                content: "";
                                position: fixed;
                                top: 0;
                                left: 0;
                                right: 0;
                                bottom: 0;
                                border: 2px solid #005D60;
                                z-index: 9999;
                                pointer-events: none;
                            }
                    `
    })
    const [lawyerData, setLawyerData] = useState([]);
    const [selectedLawyerIds, setSelectedLawyerIds] = useState([]);
    const [selectedLawyerRecords, setSelectedLawyerRecords] = useState([]);
    const [showCheckbox, setShowCheckbox] = useState(false);
    const [isSubmerchantModalOpen, setIsSubmerchantModalOpen] = useState(false);
    const [actionsMenu, setActionsMenu] = useState(actionDropdownMenu);
    const [lawyerFilter, setLawyerFilter] = useState({
        activeTab: "APPROVED", activeTabKey: "1", page: 0, size: 10, searchFilter: "", searchTermValue: "",
        fromDate: "", toDate: "", month: null, monthString: "", userStatus: "ACTIVE", isReportOpen: false, active: 0,
        documentFile: "", lawyerProfilePic: "", reason: "", blockDays: ""
    });
    const [lawyerBooleans, setLawyerBooleans] = useState({
        openProfileView: false, openComplaints: false, openInactiveModel: false, isgetLawyer: false,
        isDocumentOpen: false, profileModelOpen: false, isEditHistoryOpen: false
    });
    const [lawyerProfileData, setLawyerprofileData] = useState({});
    const [documentData, setDocumentData] = useState([]);
    const [bankDetailsModal, setBankDetailsModal] = useState({
        open: false,
        loading: false,
        data: null
    });
    const [editHistoryState, setEditHistoryState] = useState(initialEditHistoryState);
    const [consultation, setConsultation] = useState({
        activeTab: "COMPLETED", activeTabKey: "1", page: 0, size: 10, lawyerId: "", openConsultation: false,
        fromDate: "", toDate: "", month: null, monthString: "", searchFilter: "", searchTermValue: "", profile: "",
        getconsultation: false, consultationTime: ""
    });
    const [consultationBooleans, setConsultationBooleans] = useState({
        isconsultationDrawerOpen: false, isComplaintDrawerOpen: false, isConsultationReportOpen: false,
        isSendMessage: false, isSendWarningMessage: false, isComplaintReportOpen: false, isDownloadButtonEnable: false,
        isSupportDrawerOpen: false
    });
    const [consultationData, setConsultationData] = useState([]);
    const [consultationIdData, setConsultationIdData] = useState({ lawyerProfile: "", customerProfile: "", consultationInfo: {} });
    const [complaintIdData, setComplaintIDData] = useState({ rasiedByProfile: "", againstByProfile: "", data: {} });
    const [supportIdData, setSupportIdData] = useState({ profileUrl: "", data: {} });
    const [complaintsFilter, setComplaintFilters] = useState({
        activeTab: "COMPLAINT_RAISED_CUSTOMER", activeTabKey: "1", fromDate: "", toDate: "", page: 0, size: 10, month: "",
        monthString: "", searchFilter: "", searchTermValue: "", complaintStatus: "PENDING", lawyerId: "", getComplaint: false, menuType: "",
        isComplaintReportOpen: false, isAllComplaintReportOpen: false, supportId: ""
    });
    const [complaintsResponseData, setComplaintsResponseData] = useState({ lawyerResponse: {}, customerResponse: {}, lawyerProfile: "", complaintsData: [] });
    const [messageData, setMessageData] = useState({
        againstById: "",
        raisedById: "",
        body: "",
        subject: "",
        complaintType: "",
        warning: false,
        activeTab: "raised",
        complaintId: "",
        warnedBy: "",
        activeTabKey: "1",
        isWhatsapp: false,
        isMail: true,
        isButtonEnable: false
    });
    const [supportMessage, setSupportMessage] = useState({
        platforms: ["whatsapp"],
        subject: "",
        message: ""
    });

    const getLawyerDetails = (activeTab, fromDate, toDate, userStatus, searchTermValue, page, size, selectedMonthString) => api.get(`${LAWYERMANAGEMENT}/page?page=${page}&size=${size}${activeTab === "APPROVED" && userStatus ? `&userStatus=${userStatus}` : ""}${activeTab ? `&approvalStatus=${activeTab}` : ""}${selectedMonthString ? `&month=${selectedMonthString}` : ""}${fromDate && toDate ? `&stateDate=${fromDate}&endDate=${toDate}` : ""}${searchTermValue ? `&commonSearch=${searchTermValue}` : ""}`);
    const getLawyerDetailById = (id) => api.get(`${LAWYERMANAGEMENT}/${id}`);
    const getRevisedLawyerDetails = (id) => api.get(`${LAWYERMANAGEMENT}/get_revised_lawyer_details/${id}`);
    const getLawyerDocuments = (id) => api.get(`${LAWYERMANAGEMENT}/file${id}`);
    const getLawyerConsultation = (id, size, page, activeTab, fromDate, toDate, searchTermValue, monthString, consultationTime) => api.get(`${CONSULTATION}/cumulative_consultation?size=${size}&page=${page}&lawyerId=${id}${activeTab ? `&consultationStatus=${activeTab}` : ""}${fromDate && toDate ? `&stateDate=${fromDate}&endDate=${toDate}` : ""}${searchTermValue ? `&commonSearch=${searchTermValue}` : ""}${monthString ? `&month=${monthString}` : ""}${consultationTime ? `&consultationTime=${consultationTime}` : ""}`);
    const getConsultationById = (id) => api.get(`${CONSULTATION}/${id}`);
    const getComplaintById = (id) => api.get(`${COMPLAINTS}/${id}`);
    const getSupportById = (id) => api.get(`${SUPPORTMANAGEMENT}/${id}`);
    const getLawyerComplaints = (id, page, size, status, activeTab, monthString, fromDate, toDate, searchTermValue) => {
        if (activeTab === "support") {
            return api.get(`${SUPPORTMANAGEMENT}/get_support?page=${page}&size=${size}&lawyerId=${id}&complaintType=COMPLAINT_RAISED_LAWYER${status ? `&complaintStatus=${status}` : ""}${monthString ? `&month=${monthString}` : ""}${fromDate && toDate ? `&fromDate=${fromDate}&toDate=${toDate}` : ""}${searchTermValue ? `&commonSearch=${searchTermValue}` : ""}`);
        }
        return api.get(`${COMPLAINTS}/get_complaints?page=${page}&size=${size}&lawyerId=${id}${activeTab !== "support" ? `&complaintType=${activeTab}` : ""}${status ? `&complaintStatus=${status}` : ""}${monthString ? `&month=${monthString}` : ""}${fromDate && toDate ? `&fromDate=${fromDate}&toDate=${toDate}` : ""}${activeTab === "support" ? `&isSupport=${true}` : ""}${searchTermValue ? `&commonSearch=${searchTermValue}` : ""}`);
    };
    const sendWhatsAppMessage = (payload) => api.post(`${SENDMESSAGEWHATSAPP}`, payload);
    const sendMailMessage = (payload) => api.post(`${SENDMESSAGEMAILID}`, payload);
    const sendWhatsAppSupportMessage = (payload) => api.post(SENDMESSAGEWHATSAPPSUPPORT, payload);
    const sendMailSupportMessage = (payload) => api.post(SENDMESSAGEMAILSUPPORT, payload);
    const holdlawyer = (id, payload) => api.post(`${LAWYERMANAGEMENT}/hold_lawyer/${id}`, payload);
    const activeLawyer = (id) => api.post(`${LAWYERMANAGEMENT}/active_lawyer/${id}`);
    const getLawyerAccountDetails = (id) => api.get(`${ACCOUNT_DETAILS}/lawyer/${id}`);
    const getDecryptedAccountNumber = (encryptedValue) => api.get(`${ACCOUNT_DETAILS}/decrypt_account_details/${encodeURIComponent(encryptedValue)}`);

    const { data: lawyerDetailsData, refetch: fetchLawyerData, isFetching: isFetchingAllLawyerDetails } = useQuery(["FETCH_ALL_LAWYER", lawyerFilter?.activeTab, lawyerFilter?.fromDate, lawyerFilter?.toDate, lawyerFilter?.userStatus, lawyerFilter?.searchTermValue, lawyerFilter?.page, lawyerFilter?.size, lawyerFilter?.monthString], () => getLawyerDetails(lawyerFilter?.activeTab, lawyerFilter?.fromDate, lawyerFilter?.toDate, lawyerFilter?.userStatus, lawyerFilter?.searchTermValue, lawyerFilter?.page, lawyerFilter?.size, lawyerFilter?.monthString), {
        onSuccess: (lawyerResponse) => {
            if (lawyerResponse?.statusCode === 200) {
                setLawyerData(lawyerResponse?.result?.lawyerDetails?.content);
            }
        },
        enabled: Boolean(lawyerFilter?.activeTab || lawyerFilter?.fromDate || lawyerFilter?.toDate || lawyerFilter?.userStatus || lawyerFilter?.searchTermValue || lawyerFilter?.page || lawyerFilter?.size || lawyerFilter?.monthString),
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchinglawyerById } = useQuery(["FETCH_LAWYER_BY_ID", ""], getLawyerDetailById, {
        onSuccess: (lawyerByIdResponse) => {
            if (lawyerByIdResponse?.statusCode === 200) {
                if (lawyerBooleans?.isgetLawyer) {
                    setLawyerBooleans(prev => ({ ...prev, openProfileView: false, isDocumentOpen: true }));
                    const docUrlData = lawyerByIdResponse?.result?.lawyerDetails?.documentUrl;
                    let updateUrlList = [];
                    const documentNameMapping = {
                        proofdoc: "Proof Document",
                        aadharfrontsidedoc: "Aadhar Front Side",
                        aadharbacksidedoc: "Aadhar Back Side",
                        pancarddoc: "Pan Card",
                        checklistdoc: "Checklist",
                        aadhaarFront: "Aadhar Front Side",
                        aadhaarBack: "Aadhar Back Side",
                        panCard: "Pan Card",
                        checkLeaf: "Check Leaf",
                        professionalCertificate: "Professional Certificate",
                        proofUrl: "Proof Document",
                        teamsAndConditions: "Terms and Condition",
                        termsAndConditions: "Terms and Condition",
                        teamsAndCondition: "Terms and Condition",
                        termsAndCondition: "Terms and Condition",
                        termsandconditions: "Terms and Condition",
                        teamsandconditions: "Terms and Condition",
                        termscondition: "Terms and Condition",
                        teamscondition: "Terms and Condition",
                        terms: "Terms and Condition"
                    };
                    const resolveDocName = (keyOrUrl, index) => {
                        if (!keyOrUrl) return `Document ${index + 1}`;
                        if (documentNameMapping[keyOrUrl]) return documentNameMapping[keyOrUrl];
                        const cleanStr = String(keyOrUrl).toLowerCase();
                        for (const [key, label] of Object.entries(documentNameMapping)) {
                            if (cleanStr.includes(key.toLowerCase())) {
                                return label;
                            }
                        }
                        if ((cleanStr.includes("team") || cleanStr.includes("term")) && cleanStr.includes("condition")) {
                            return "Terms and Condition";
                        }
                        const fileName = String(keyOrUrl).split('/').pop();
                        return fileName || `Document ${index + 1}`;
                    };
                    if (docUrlData) {
                        if (Array.isArray(docUrlData)) {
                            updateUrlList = docUrlData
                                .filter(Boolean)
                                .map((url, index) => ({
                                    id: url,
                                    name: resolveDocName(url, index),
                                    url: url.startsWith('/file/file-document') ? `${LAWYERMANAGEMENT}${url}` : `${LAWYERMANAGEMENT}/file${url}`,
                                    type: url.split('.').pop() || 'pdf',
                                    uploadDate: new Date().toLocaleDateString()
                                }));
                        } else if (typeof docUrlData === 'object') {
                            updateUrlList = Object.entries(docUrlData)
                                .filter(([_, url]) => Boolean(url))
                                .map(([key, url], index) => ({
                                    id: url,
                                    name: documentNameMapping[key] || resolveDocName(key || url, index),
                                    url: url.startsWith('/file/file-document') ? `${LAWYERMANAGEMENT}${url}` : `${LAWYERMANAGEMENT}/file${url}`,
                                    type: url.split('.').pop() || 'pdf',
                                    uploadDate: new Date().toLocaleDateString()
                                }));
                        }
                    }
                    setDocumentData(updateUrlList);
                    handleViewDocument(updateUrlList?.[0], 0);
                }
                else {
                    setLawyerBooleans(prev => ({ ...prev, openProfileView: true }));
                    setLawyerprofileData(lawyerByIdResponse?.result?.lawyerDetails);
                    setLawyerFilter(prev => ({ ...prev, lawyerProfilePic: `${LAWYERMANAGEMENT}/file${lawyerByIdResponse?.result?.lawyerDetails?.profileUrl}` }));
                }
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingLawyerDocuments } = useQuery(["FETCH_DOCUMENTS", ""], getLawyerDocuments, {
        onSuccess: async (documentResponse) => {
            const blob = new Blob([documentResponse], { type: "application/pdf" });
            const arrayBuffer = await blob.arrayBuffer();
            const url = new Uint8Array(arrayBuffer);
            setLawyerFilter(prev => ({ ...prev, documentFile: url }));
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { data: allConsultationData, isFetching: isFetchingLawyerConsultationById } =
        useQuery(["FETCH_lAWYER_CONSULTATION_BY_ID", consultation?.lawyerId, consultation?.size, consultation?.page, consultation?.activeTab, consultation?.fromDate, consultation?.toDate, consultation?.searchTermValue, consultation?.monthString, consultation?.consultationTime],
            () => getLawyerConsultation(consultation?.lawyerId, consultation?.size, consultation?.page, consultation?.activeTab, consultation?.fromDate, consultation?.toDate, consultation?.searchTermValue, consultation?.monthString, consultation?.consultationTime), {
            onSuccess: (consultationResponse) => {
                if (consultationResponse?.statusCode === 200) {
                    setConsultation(prev => ({ ...prev, openConsultation: true, profile: `${LAWYERMANAGEMENT}/file${consultationResponse?.result?.consultationCumulativeResponse?.lawyerResponse?.profileUrl}` }));
                    setConsultationData(consultationResponse?.result?.consultationCumulativeResponse?.consultationResponsePage?.content);
                }
                else {
                    setConsultation(prev => ({ ...prev, getconsultation: false }));
                    showErrorNotification("Error", consultationResponse?.response?.data?.error?.message);
                }
            },
            enabled: consultation?.getconsultation && Boolean(consultation?.lawyerId || consultation?.activeTab || consultation?.page || consultation?.size || consultation?.fromDate || consultation?.toDate || consultation?.searchTermValue || consultation?.monthString || consultation?.consultationTime),
            refetchOnWindowFocus: false
        });

    const { isFetching: isFetchingConsultationById } = useQuery(["FETCH_CONSULTATION_BY_ID", ""], getConsultationById, {
        onSuccess: (consultationIdResponse) => {
            if (consultationIdResponse?.statusCode === 200) {
                setConsultationBooleans(prev => ({ ...prev, isconsultationDrawerOpen: true }));
                setConsultationIdData(prev => ({
                    ...prev,
                    lawyerProfile: `${LAWYERMANAGEMENT}/file${consultationIdResponse?.result?.consultationResponse?.lawyerResponse?.profileUrl}`,
                    customerProfile: `${CUSTOMERMANAGEMENT}/file${consultationIdResponse?.result?.consultationResponse?.customerResponse?.profileUrl}`,
                    consultationInfo: consultationIdResponse?.result?.consultationResponse
                }));
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingComplaintById } = useQuery(["FETCH_COMPLAINT_BY_ID", ""], getComplaintById, {
        onSuccess: (complaintResponse) => {
            if (complaintResponse?.statusCode === 200) {
                if (complaintsFilter?.menuType === "report") {
                    setComplaintFilters(prev => ({ ...prev, isComplaintReportOpen: true }));
                    setConsultationBooleans(prev => ({ ...prev, isComplaintDrawerOpen: false }));
                }
                else {
                    setComplaintFilters(prev => ({ ...prev, isComplaintReportOpen: false }));
                    setConsultationBooleans(prev => ({ ...prev, isComplaintDrawerOpen: true }));
                }
                const isCustomerRaised = complaintIdData?.complaintType === "COMPLAINT_RAISED_CUSTOMER";
                setComplaintIDData(prev => ({ ...prev, rasiedByProfile: `${isCustomerRaised ? CUSTOMERMANAGEMENT : LAWYERMANAGEMENT}file/${complaintResponse?.result?.complaintResponse?.raisedByProfileUrl}`, againstByProfile: `${isCustomerRaised ? CUSTOMERMANAGEMENT : LAWYERMANAGEMENT}/file${complaintResponse?.result?.complaintResponse?.againstByProfileUrl}`, data: complaintResponse?.result?.complaintResponse }));
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingSupportById } = useQuery(["FETCH_SUPPORT_BY_ID", complaintsFilter?.supportId], () => getSupportById(complaintsFilter?.supportId), {
        onSuccess: (supportResponse) => {
            if (supportResponse?.statusCode === 200) {
                setConsultationBooleans(prev => ({ ...prev, isSupportDrawerOpen: true }));
                const data = supportResponse?.result?.supportResponse;
                setSupportIdData(prev => ({
                    ...prev,
                    profileUrl: `${LAWYERMANAGEMENT}/file${data?.raisedByProfileUrl}`,
                    data: data
                }));
                let platforms = ['whatsapp'];
                if (data?.complaintStatus === 'COMPLETED' && data?.supportedIn) {
                    platforms = [];
                    if (data?.supportedIn?.includes('WHATSAPP')) {
                        platforms.push('whatsapp');
                    }
                    if (data?.supportedIn?.includes('EMAIL')) {
                        platforms.push('email');
                    }
                }
                setSupportMessage(prev => ({ ...prev, platforms: platforms, message: data?.actionItem || '', subject: data?.subjectActionItem || '' }));
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { data: allComplaints, refetch: fetchComplaints, isFetching: isFetchingLawyerComplaints } = useQuery(["FETCH_LAWYER_COMPLAINTS", complaintsFilter?.lawyerId, complaintsFilter?.page, complaintsFilter?.size, complaintsFilter?.complaintStatus, complaintsFilter?.activeTab, complaintsFilter?.monthString, complaintsFilter?.fromDate, complaintsFilter?.toDate, complaintsFilter?.searchTermValue], () => getLawyerComplaints(complaintsFilter?.lawyerId, complaintsFilter?.page, complaintsFilter?.size, complaintsFilter?.complaintStatus, complaintsFilter?.activeTab, complaintsFilter?.monthString, complaintsFilter?.fromDate, complaintsFilter?.toDate, complaintsFilter?.searchTermValue), {
        onSuccess: (complaintResponse) => {
            if (complaintResponse?.statusCode === 200) {
                setComplaintFilters(prev => ({ ...prev, openComplaints: true }));
                const result = complaintResponse?.result;
                const details = result?.lawyerComplaintDetails || result?.supportDetailsResponse;
                const pageData = details?.complaintResponsePage || details?.supportResponsePage;
                setComplaintsResponseData(prev => ({
                    ...prev, lawyerResponse: details?.lawyerResponse,
                    customerResponse: details?.customerResponse,
                    complaintsData: pageData?.content,
                    lawyerProfile: `${LAWYERMANAGEMENT}/file${details?.lawyerResponse?.profileUrl}`
                }));
            }
            else {
                setComplaintFilters(prev => ({ ...prev, getComplaint: false }));
                showErrorNotification("Error", complaintResponse?.response?.data?.error?.message);
            }
        },
        enabled: complaintsFilter?.getComplaint && Boolean(complaintsFilter?.lawyerId || complaintsFilter?.page || complaintsFilter?.size || complaintsFilter?.complaintStatus || complaintsFilter?.activeTab || complaintsFilter?.monthString || complaintsFilter?.fromDate || complaintsFilter?.toDate || complaintsFilter?.searchTermValue),
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingSendMessage } = useQuery(["SEND_MESSAGE_WHATSAPP", ""], sendWhatsAppMessage, {
        onSuccess: (sendResponse) => {
            if (sendResponse?.data?.statusCode === 200) {
                handleSendMessageClose();
                setConsultationBooleans(prev => ({ ...prev, isSendMessage: false, isSendWarningMessage: false }));
                setMessageData(prev => ({ ...prev, activeTab: "raised", activeTabKey: "1", isMail: true, isWhatsapp: false, body: "", subject: "" }));
                showSuccessNotification("Success", sendResponse?.data?.result?.message);
                fetchComplaints();
                setConsultationBooleans(prev => ({ ...prev, isComplaintDrawerOpen: false }));
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingSenfMailMessage } = useQuery(["SEND_MESSAGE_MAIL", ""], sendMailMessage, {
        onSuccess: (mailResponse) => {
            if (mailResponse?.data?.statusCode === 200) {
                setConsultationBooleans(prev => ({ ...prev, isSendMessage: false, isSendWarningMessage: false }));
                setMessageData(prev => ({ ...prev, activeTab: "raised", activeTabKey: "1", isMail: true, isWhatsapp: false, body: "", subject: "" }));
                showSuccessNotification("Success", mailResponse?.data?.result?.message);
                fetchComplaints();
                setConsultationBooleans(prev => ({ ...prev, isComplaintDrawerOpen: false }));
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingSendSupportWhatsApp } = useQuery(["SEND_MESSAGE_WHATSAPP_SUPPORT", ""], sendWhatsAppSupportMessage, {
        onSuccess: (sendResponse) => {
            if (sendResponse?.data?.statusCode === 200) {
                showSuccessNotification("Success", sendResponse?.data?.result?.message);
                setConsultationBooleans(prev => ({ ...prev, isSupportDrawerOpen: false }));
                setSupportMessage({ platforms: ["whatsapp"], subject: "", message: "" });
                fetchComplaints();
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingSendSupportMail } = useQuery(["SEND_MESSAGE_MAIL_SUPPORT", ""], sendMailSupportMessage, {
        onSuccess: (mailResponse) => {
            if (mailResponse?.data?.statusCode === 200) {
                showSuccessNotification("Success", mailResponse?.data?.result?.message || mailResponse?.data?.result?.response);
                setConsultationBooleans(prev => ({ ...prev, isSupportDrawerOpen: false }));
                setSupportMessage({ platforms: ["whatsapp"], subject: "", message: "" });
                fetchComplaints();
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingHoldLawyer } = useQuery(["HOLD_LAWYER", ""], holdlawyer, {
        onSuccess: (holdresponse) => {
            if (holdresponse?.data?.statusCode === 200) {
                setLawyerBooleans(prev => ({ ...prev, openInactiveModel: false }));
                showSuccessNotification("Success", holdresponse?.data?.result?.response);
                fetchLawyerData();
                setLawyerFilter(prev => ({ ...prev, reason: "", blockDays: "" }));
            }
            else {
                showErrorNotification("Error", holdresponse?.response?.data?.error?.message || "Could not hold the lawyer. Please try again later.");
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingActivelawyer } = useQuery(["ACTIVATE_LAWYER", ""], activeLawyer, {
        onSuccess: (activeresponse) => {
            if (activeresponse?.data?.statusCode === 200) {
                setLawyerBooleans(prev => ({ ...prev, openInactiveModel: false }));
                showSuccessNotification("Success", activeresponse?.data?.result?.response);
                fetchLawyerData();
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingAccountDetails } = useQuery(["FETCH_ACCOUNT_DETAILS", ""], getLawyerAccountDetails, {
        onSuccess: (accountResponse) => {
            if (accountResponse?.statusCode === 200 && accountResponse?.result) {
                const bankList = accountResponse?.result?.lawyerDetailResponse?.bankDetails || accountResponse?.result?.bankDetails || [];
                const primaryBank = Array.isArray(bankList)
                    ? (bankList.find((item) => item?.primary) || bankList[0])
                    : (bankList || null);

                if (primaryBank) {
                    if (primaryBank?.encryptAccountNumber && !primaryBank?.decryptAccountNumber) {
                        setBankDetailsModal(prev => ({
                            ...prev,
                            loading: true,
                            data: primaryBank
                        }));
                        queryClient.prefetchQuery(["FETCH_DECRYPT_ACCOUNT", ""], () => getDecryptedAccountNumber(primaryBank.encryptAccountNumber));
                        return;
                    }

                    setBankDetailsModal({
                        open: true,
                        loading: false,
                        data: primaryBank
                    });
                    return;
                }
            }

            setBankDetailsModal(prev => ({
                open: true,
                loading: false,
                data: prev?.data || null
            }));
        },
        onError: () => {
            setBankDetailsModal(prev => ({
                open: true,
                loading: false,
                data: prev?.data || null
            }));
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingDecryptAccount } = useQuery(["FETCH_DECRYPT_ACCOUNT", ""], getDecryptedAccountNumber, {
        onSuccess: (decryptResponse) => {
            let decryptedAccountNumber = "";
            if (decryptResponse?.result?.decrypted) {
                decryptedAccountNumber = decryptResponse.result.decrypted;
            } else if (typeof decryptResponse?.result === "string") {
                decryptedAccountNumber = decryptResponse.result;
            } else if (decryptResponse?.result?.accountNumber || decryptResponse?.result?.decryptAccountNumber) {
                decryptedAccountNumber = decryptResponse.result.accountNumber || decryptResponse.result.decryptAccountNumber;
            } else if (decryptResponse?.data?.decrypted) {
                decryptedAccountNumber = decryptResponse.data.decrypted;
            } else if (typeof decryptResponse?.data === "string") {
                decryptedAccountNumber = decryptResponse.data;
            } else if (decryptResponse?.data?.accountNumber || decryptResponse?.data?.decryptAccountNumber) {
                decryptedAccountNumber = decryptResponse.data.accountNumber || decryptResponse.data.decryptAccountNumber;
            } else if (decryptResponse?.result) {
                decryptedAccountNumber = String(decryptResponse.result);
            }

            setBankDetailsModal(prev => ({
                open: true,
                loading: false,
                data: {
                    ...prev?.data,
                    decryptAccountNumber: decryptedAccountNumber || prev?.data?.decryptAccountNumber || prev?.data?.accountNumber,
                    accountNumber: decryptedAccountNumber || prev?.data?.accountNumber
                }
            }));
        },
        onError: () => {
            setBankDetailsModal(prev => ({
                open: true,
                loading: false,
                data: prev?.data || null
            }));
        },
        enabled: false,
        refetchOnWindowFocus: false
    });


    const getConsultationDropdown = (details) => {
        const lawyerComplaint = details?.lawyerComplaintDto && Object.keys(details?.lawyerComplaintDto)?.length > 0;
        const customerComplaint = details?.customerComplaintDto && Object.keys(details?.customerComplaintDto)?.length > 0;
        if (lawyerComplaint && customerComplaint) {
            return [
                { key: "view", label: "View" },
                { key: "viewLawyerRasiedComplaints", label: "View Advocate Rasied Complaint" },
                { key: "viewCustiomerRasiedComplaint", label: "View Customer Rasied Complaint" },
            ]
        }
        else if (lawyerComplaint || customerComplaint) {
            return [
                { key: "view", label: "View" },
                { key: "viewComplaint", label: "View Complaints" },
            ]
        }
        else {
            return [
                { key: "view", label: "View" },
            ]
        }
    };


    const handleTabChanges = (key) => {
        tabData?.forEach((tab) => {
            if (tab?.key === key) {
                const { content } = tab || {};
                setLawyerFilter(prev => ({ ...prev, activeTab: content }));
            }
        });
        setLawyerFilter(prev => ({ ...prev, activeTabKey: key, userStatus: "ACTIVE", page: 0, size: 10, fromDate: "", toDate: "", searchFilter: "", searchTermValue: "", month: null, monthString: "" }));
        setActionsMenu(actionDropdownMenu);
        setSelectedLawyerIds([]);
        setSelectedLawyerRecords([]);
        setShowCheckbox(false);
    };

    const handleConsultationTabChange = (key) => {
        consultationTabData?.forEach((tab) => {
            if (tab?.key === key) {
                const { content } = tab || {};
                setConsultation(prev => ({ ...prev, activeTab: content, month: null, monthString: "", page: 0, size: 10, searchFilter: "", searchTermValue: "", consultationTime: "", fromDate: "", toDate: "" }));
            }
        });
        setConsultation(prev => ({ ...prev, activeTabKey: key, page: 0, size: 10 }));
    };

    const handleComplaintTabChange = (key) => {
        complaintesTabData?.forEach((tab) => {
            if (tab?.key === key) {
                const { content } = tab || {};
                setComplaintFilters(prev => ({ ...prev, activeTab: content, month: null, monthString: "", page: 0, size: 10, searchFilter: "", searchTermValue: "", fromDate: "", toDate: "", complaintStatus: "PENDING" }));
            }
        })
        setComplaintFilters(prev => ({ ...prev, activeTabKey: key, page: 0, size: 10 }));
    };

    const handlePagination = (page, size, type) => {
        if (type === "lawyer") {
            setLawyerFilter(prev => ({ ...prev, page: page - 1, size: size }));
        }
        else if (type === "complaints") {
            setComplaintFilters(prev => ({ ...prev, page: page - 1, size: size }));
        }
        else if (type === "consultation") {
            setConsultation(prev => ({ ...prev, page: page - 1, size: size }));
        }
    };

    const handleAction = (menuType, list) => {
        if (menuType === "view") {
            queryClient.prefetchQuery(["FETCH_LAWYER_BY_ID", ""], () => getLawyerDetailById(list?.lawyerId));
        }
        else if (menuType === "inactive" || menuType === "active" || menuType === "hold") {
            setLawyerBooleans(prev => ({ ...prev, openInactiveModel: true }));
            setLawyerFilter(prev => ({ ...prev, lawyerId: list?.lawyerId }));
        }
        else if (menuType === "editHistory") {
            dispatch(loaderReducer(true));
            Promise.all([
                getRevisedLawyerDetails(list?.lawyerId),
                getLawyerDetailById(list?.lawyerId)
            ]).then(([revisedResponse, currentResponse]) => {
                const revisedList = revisedResponse?.result?.revisedLawyerDetailsResponse || [];
                const currentLawyerDetail = currentResponse?.result?.lawyerDetails || {};
                const selectedLawyerName = `${currentLawyerDetail?.firstName || ""} ${currentLawyerDetail?.middleName || ""} ${currentLawyerDetail?.lastName || ""}`?.trim();
                const revisedHistoryList = revisedList?.map((revisedDetail) => ({
                    ...revisedDetail,
                    revisedDate: revisedDetail?.revisedDate,
                    action: "View",
                    currentLawyerDetail: currentLawyerDetail
                }));
                setEditHistoryState(prev => ({
                    ...prev,
                    editHistoryData: revisedHistoryList || [],
                    selectedLawyerName: selectedLawyerName,
                    selectedLawyerProfile: {
                        name: selectedLawyerName,
                        lawyerId: currentLawyerDetail?.lawyerNo || "Nil",
                        mobileNumber: currentLawyerDetail?.mobileNumber || "Nil",
                        lastName: currentLawyerDetail?.lastName || "Nil",
                        email: currentLawyerDetail?.email || "Nil",
                        warningCountAfterActive: currentLawyerDetail?.warningCountAfterActive || 0,
                        profilePic: currentLawyerDetail?.profileUrl ? `${LAWYERMANAGEMENT}/file${currentLawyerDetail?.profileUrl}` : ""
                    }
                }));
                setLawyerBooleans(prev => ({ ...prev, isEditHistoryOpen: true }));
            }).catch((error) => {
                showErrorNotification("Error", error?.response?.data?.error?.message || "Failed to fetch edit history");
            }).finally(() => {
                dispatch(loaderReducer(false));
            });
        }
        else if (menuType === "complaints") {
            setComplaintFilters(prev => ({ ...prev, lawyerId: list?.lawyerId, getComplaint: true }));
        }
        else if (menuType === "consultation") {
            setConsultation(prev => ({ ...prev, lawyerId: list?.lawyerId, getconsultation: true }));
        }
    };

    const handleConsultationAction = (menuType, list) => {
        if (menuType === "view") {
            queryClient.prefetchQuery(["FETCH_CONSULTATION_BY_ID", ""], () => getConsultationById(list?.consultationId));
        }
        else if (menuType === "viewComplaint") {
            setConsultationBooleans(prev => ({ ...prev, isDownloadButtonEnable: true }));
            let complaintId = null;
            if (list?.lawyerComplaintDto && Object.keys(list?.lawyerComplaintDto)?.length > 0) {
                complaintId = list.lawyerComplaintDto?.complaintId;
            }

            if (list?.customerComplaintDto && Object.keys(list?.customerComplaintDto)?.length > 0) {
                complaintId = list?.customerComplaintDto?.complaintId;
            }
            queryClient.prefetchQuery(["FETCH_COMPLAINT_BY_ID", ""], () => getComplaintById(complaintId));
        }
        else if (menuType === "viewLawyerRasiedComplaints") {
            setConsultationBooleans(prev => ({ ...prev, isDownloadButtonEnable: true }));
            queryClient.prefetchQuery(["FETCH_COMPLAINT_BY_ID", ""], () => getComplaintById(list?.lawyerComplaintDto?.complaintId));
        }
        else if (menuType === "viewCustiomerRasiedComplaint") {
            setConsultationBooleans(prev => ({ ...prev, isDownloadButtonEnable: true }));
            queryClient.prefetchQuery(["FETCH_COMPLAINT_BY_ID", ""], () => getComplaintById(list?.customerComplaintDto?.complaintId));
        }
    };

    const handleComplaintAction = (menuType, list) => {
        if (menuType === "view") {
            if (complaintsFilter?.activeTab === "support") {
                setComplaintFilters(prev => ({ ...prev, supportId: list?.supportId }));
                queryClient.prefetchQuery(["FETCH_SUPPORT_BY_ID", list?.supportId], () => getSupportById(list?.supportId));
            } else {
                setComplaintFilters(prev => ({ ...prev, menuType: "view" }));
                setConsultationBooleans(prev => ({ ...prev, isDownloadButtonEnable: false }));
                queryClient.prefetchQuery(["FETCH_COMPLAINT_BY_ID", ""], () => getComplaintById(list?.complaintId));
            }
        }
        else if (menuType === "report") {
            setComplaintFilters(prev => ({ ...prev, menuType: "report" }));
            queryClient.prefetchQuery(["FETCH_COMPLAINT_BY_ID", ""], () => getComplaintById(list?.complaintId));
        }
    };

    const menuList = (menuItems, list) => {
        return <Menu>
            {
                menuItems?.map((menuDetails) => {
                    return <Menu.Item key={menuDetails?.key}
                        onClick={(event) => {
                            event?.domEvent?.stopPropagation();
                            handleAction(menuDetails?.key, list);
                        }}
                    >{menuDetails?.label}</Menu.Item>
                })
            }
        </Menu>
    };

    const consultMenuList = (menuItems, list) => {
        return <Menu>
            {
                menuItems?.map((menuDetails) => {
                    return <Menu.Item key={menuDetails?.key} onClick={(event) => {
                        event?.domEvent?.stopPropagation();
                        handleConsultationAction(menuDetails?.key, list);
                    }}>
                        {menuDetails?.label}
                    </Menu.Item>
                })
            }
        </Menu>
    };

    const complantMenuList = (menuItems, list) => {
        return <Menu>
            {
                menuItems?.map((menuDetails) => {
                    return <Menu.Item key={menuDetails?.key} onClick={(event) => {
                        event?.domEvent?.stopPropagation();
                        handleComplaintAction(menuDetails?.key, list);
                    }}>
                        {menuDetails?.label}
                    </Menu.Item>
                })
            }
        </Menu>
    };

    const actionRender = (list) => {
        return <Dropdown overlay={menuList(actionsMenu, list)} trigger={["click"]}>
            <Space onClick={(event) => {
                event?.preventDefault();
                event?.stopPropagation();
            }} style={{ justifyContent: "center", width: "100%", cursor: "pointer" }}>
                <img src={actionDots} alt="Action Dots" />
            </Space>
        </Dropdown>
    };

    const handleLawyerRowClick = (lawyerDetail) => {
        if (lawyerFilter?.activeTab === "APPROVED") {
            handleAction("view", lawyerDetail);
        }
        else {
            handleRejectedLawyers(lawyerDetail);
        }
    };

    const consultationActionRender = (list, filteredList) => {
        return <Dropdown overlay={(consultMenuList(consultation?.activeTab === "COMPLETED" || consultation?.activeTab === "CANCELLED" ? filteredList : pendingConsultationDropdown, list))} trigger={["click"]}>
            <Space onClick={(space) => {
                space?.preventDefault();
                space?.stopPropagation();
            }} style={{ justifyContent: "center", width: "100%", cursor: "pointer" }}>
                <img src={actionDots} alt="ActionDots" />
            </Space>
        </Dropdown>
    };

    const complaintActionRender = (list) => {
        return <Dropdown overlay={(complantMenuList(complaintAgainstDropdown, list))} trigger={["click"]}>
            <Space onClick={(space) => {
                space?.preventDefault();
                space?.stopPropagation();
            }} style={{ justifyContent: "center", width: "100%", cursor: "pointer" }}>
                <img src={actionDots} alt="ActionDots" />
            </Space>
        </Dropdown>
    };

    const handleProfileCancel = () => {
        setLawyerBooleans(prev => ({ ...prev, openProfileView: false }));
        setLawyerprofileData({});
    };

    const handleComplaintsCancel = () => {
        setComplaintFilters(prev => ({ ...prev, getComplaint: false, openComplaints: false, activeTab: "COMPLAINT_RAISED_CUSTOMER", activeTabKey: "1", page: 0, size: 10, monthString: "", month: null, fromDate: "", toDate: "", searchTermValue: "", menuType: "", complaintStatus: "PENDING" }));
        setComplaintIDData({ rasiedByProfile: "", againstByProfile: "", data: {} });
        fetchLawyerData();
    };

    const handleConsultationCancel = () => {
        setConsultation(prev => ({ ...prev, getconsultation: false, activeTab: "COMPLETED", openConsultation: false, activeTabKey: "1", page: 0, size: 10, monthString: "", month: null, fromDate: "", toDate: "", searchTermValue: "" }));
        setConsultationIdData({ lawyerProfile: "", customerProfile: "", consultationInfo: {} });
        fetchLawyerData();
    };

    const handleReportPrint = () => {
        setLawyerFilter(prev => ({ ...prev, size: -1, isReportOpen: true }));
    };

    const handleDateChange = (date, type) => {
        const fromDate = dayjs(date?.[0]).format("YYYY-MM-DD");
        const toDate = dayjs(date?.[1]).format("YYYY-MM-DD");
        if (date) {
            if (fromDate && toDate) {
                if (type === "lawyer") {
                    setLawyerFilter(prev => ({ ...prev, fromDate: fromDate, toDate: toDate, month: null, monthString: "" }));
                }
                else if (type === "complaints") {
                    setComplaintFilters(prev => ({ ...prev, fromDate: fromDate, toDate: toDate, month: null, monthString: "" }));
                }
                else if (type === "consultation") {
                    setConsultation(prev => ({ ...prev, prev, fromDate: fromDate, toDate: toDate, month: null, monthString: "" }));
                }
            }
        }
        else {
            if (type === "lawyer") {
                setLawyerFilter(prev => ({ ...prev, fromDate: "", toDate: "" }));
            }
            else if (type === "complaints") {
                setComplaintFilters(prev => ({ ...prev, fromDate: "", toDate: "" }));
            }
            else if (type === "consultation") {
                setConsultation(prev => ({ ...prev, prev, fromDate: "", toDate: "" }));
            }
        }
    };

    const handleSearch = (searchValue, type) => {
        const searchTerm = searchValue;
        if (type === "lawyer") {
            setLawyerFilter(prev => ({ ...prev, searchFilter: searchTerm }));
        }
        else if (type === "consultation") {
            setConsultation(prev => ({ ...prev, searchFilter: searchTerm }));
        }
        else if (type === "complaints") {
            setComplaintFilters(prev => ({ ...prev, searchFilter: searchTerm }));
        }
        debounceSearch(searchTerm, type);
    };

    const debounceSearch = (searchTerm, type) => {
        if (debounceTimeOut?.current) {
            clearTimeout(debounceTimeOut?.current);
        }
        if (searchTerm !== "") {
            debounceTimeOut.current = setTimeout(() => {
                if (type === "lawyer") {
                    setLawyerFilter(prev => ({ ...prev, searchTermValue: searchTerm, page: 0, size: 10 }));
                }
                else if (type === "consultation") {
                    setConsultation(prev => ({ ...prev, searchTermValue: searchTerm, pageSize: { ...prev?.pageSize, page: 0, size: 10 }, }));
                }
                else if (type === "complaints") {
                    setComplaintFilters(prev => ({ ...prev, searchTermValue: searchTerm, page: 0, size: 10 }));
                }

            }, searchInitiateDelayTime);
        }
        else {
            if (type === "lawyer") {
                setLawyerFilter(prev => ({ ...prev, searchTermValue: "", page: 0, size: 10 }));
            }
            else if (type === "consultation") {
                setConsultation(prev => ({ ...prev, searchTermValue: "", page: 0, size: 10 }));
            }
            else if (type === "complaints") {
                setComplaintFilters(prev => ({ ...prev, searchTermValue: "", page: 0, size: 10 }));
            }
        }
    };

    const handleActiveInactiveFilter = (selectedValue,) => {
        setLawyerFilter(prev => ({ ...prev, userStatus: selectedValue }));
        let updatedMenu = [...actionDropdownMenu];
        if (selectedValue === "ACTIVE") {
            updatedMenu = actionDropdownMenu?.map(item =>
                item.key === "hold"
                    ? { ...item, key: "hold", label: "Hold" }
                    : item
            );
        }
        if (selectedValue === "INACTIVE" || selectedValue === "HOLD") {
            updatedMenu = actionDropdownMenu?.map(item =>
                item.key === "hold"
                    ? { ...item, key: "active", label: "Active" }
                    : item
            );
        }
        setActionsMenu(updatedMenu);
    };

    const handleRejectedLawyers = (list) => {
        queryClient.prefetchQuery(["FETCH_LAWYER_BY_ID", ""], () => getLawyerDetailById(list?.lawyerId));
    };

    const handleDocuments = (list) => {
        setLawyerBooleans(prev => ({ ...prev, isgetLawyer: true }));
        queryClient.prefetchQuery(["FETCH_LAWYER_BY_ID", ""], () => getLawyerDetailById(list?.lawyerId))
    };

    const handleBankDetails = (detail) => {
        const lawyerId = detail?.lawyerId || detail?.id;
        const fallbackBankData = detail?.bankDetails || detail;

        setBankDetailsModal({
            open: true,
            loading: Boolean(lawyerId),
            data: fallbackBankData || null
        });

        if (lawyerId) {
            queryClient.prefetchQuery(["FETCH_ACCOUNT_DETAILS", ""], () => getLawyerAccountDetails(lawyerId));
        }
    };


    const handleBankDetailsClose = () => {
        setBankDetailsModal({ open: false, loading: false, data: null });
    };

    const handleSelectLawyer = (lawyerId, record) => {
        setSelectedLawyerIds(prev => {
            if (prev.includes(lawyerId)) {
                return prev.filter(id => id !== lawyerId);
            } else {
                return [...prev, lawyerId];
            }
        });
        setSelectedLawyerRecords(prev => {
            const exists = prev.some(item => (item?.lawyerId || item?.id) === lawyerId);
            if (exists) {
                return prev.filter(item => (item?.lawyerId || item?.id) !== lawyerId);
            } else {
                return [...prev, record];
            }
        });
    };

    const handleSelectAll = (checked) => {
        const currentVisibleIds = (lawyerData || []).map(item => item?.lawyerId || item?.id).filter(Boolean);
        if (checked) {
            setSelectedLawyerIds(prev => Array.from(new Set([...prev, ...currentVisibleIds])));
            setSelectedLawyerRecords(prev => {
                const map = new Map(prev.map(item => [item?.lawyerId || item?.id, item]));
                (lawyerData || []).forEach(item => {
                    const id = item?.lawyerId || item?.id;
                    if (id) map.set(id, item);
                });
                return Array.from(map.values());
            });
        } else {
            setSelectedLawyerIds(prev => prev.filter(id => !currentVisibleIds.includes(id)));
            setSelectedLawyerRecords(prev => prev.filter(item => !currentVisibleIds.includes(item?.lawyerId || item?.id)));
        }
    };

    const handleOpenExcelModal = () => {
        if (selectedLawyerIds?.length === 0) {
            showErrorNotification("Warning", "Please select at least one advocate to download report.");
            return;
        }
        setIsSubmerchantModalOpen(true);
    };

    const handleDownloadExcelReport = async (submerchantMap = {}, emailDetails = {}) => {
        if (selectedLawyerIds?.length === 0) {
            showErrorNotification("Warning", "Please select at least one advocate to download report.");
            return;
        }

        dispatch(loaderReducer(true));
        try {
            const recordsToExport = await Promise.all(selectedLawyerIds.map(async (id) => {
                const foundRecord = selectedLawyerRecords.find(item => (item?.lawyerId || item?.id) === id)
                    || lawyerData.find(item => (item?.lawyerId || item?.id) === id)
                    || { id, lawyerId: id };

                const key = foundRecord?.lawyerId || foundRecord?.id || foundRecord?.lawyerNo || id;
                const subDetails = submerchantMap?.[key] || submerchantMap?.[id] || submerchantMap?.[foundRecord?.lawyerNo] || {};

                let primaryBank = null;
                const existingBank = foundRecord?.bankDetails;
                if (existingBank && (Array.isArray(existingBank) ? existingBank.length > 0 : Boolean(existingBank?.accountNumber || existingBank?.encryptAccountNumber || existingBank?.bankName))) {
                    const bankList = Array.isArray(existingBank) ? existingBank : [existingBank];
                    primaryBank = bankList.find((item) => item?.primary) || bankList[0];
                }
                if (!primaryBank || !primaryBank?.bankName || (primaryBank?.encryptAccountNumber && !primaryBank?.decryptAccountNumber)) {
                    try {
                        const accountRes = await getLawyerAccountDetails(id);
                        if (accountRes?.statusCode === 200 && accountRes?.result) {
                            const fetchedBankList = accountRes?.result?.lawyerDetailResponse?.bankDetails || accountRes?.result?.bankDetails || [];
                            const fetchedPrimary = Array.isArray(fetchedBankList)
                                ? (fetchedBankList.find((item) => item?.primary) || fetchedBankList[0])
                                : fetchedBankList;
                            if (fetchedPrimary) {
                                primaryBank = { ...fetchedPrimary };
                            }
                        }
                    } catch (err) {
                        console.error("Error fetching account details for lawyer:", id, err);
                    }
                }
                if (primaryBank?.encryptAccountNumber && !primaryBank?.decryptAccountNumber) {
                    try {
                        const decryptRes = await getDecryptedAccountNumber(primaryBank.encryptAccountNumber);
                        let decryptedAccountNumber = "";
                        if (decryptRes?.result?.decrypted) {
                            decryptedAccountNumber = decryptRes.result.decrypted;
                        } else if (typeof decryptRes?.result === "string") {
                            decryptedAccountNumber = decryptRes.result;
                        } else if (decryptRes?.result?.accountNumber || decryptRes?.result?.decryptAccountNumber) {
                            decryptedAccountNumber = decryptRes.result.accountNumber || decryptRes.result.decryptAccountNumber;
                        } else if (decryptRes?.data?.decrypted) {
                            decryptedAccountNumber = decryptRes.data.decrypted;
                        } else if (typeof decryptRes?.data === "string") {
                            decryptedAccountNumber = decryptRes.data;
                        } else if (decryptRes?.data?.accountNumber || decryptRes?.data?.decryptAccountNumber) {
                            decryptedAccountNumber = decryptRes.data.accountNumber || decryptRes.data.decryptAccountNumber;
                        } else if (decryptRes?.result) {
                            decryptedAccountNumber = String(decryptRes.result);
                        }

                        if (decryptedAccountNumber) {
                            primaryBank = {
                                ...primaryBank,
                                decryptAccountNumber: decryptedAccountNumber,
                                accountNumber: decryptedAccountNumber
                            };
                        }
                    } catch (err) {
                        console.error("Error decrypting account number for lawyer:", id, err);
                    }
                }

                return {
                    ...foundRecord,
                    submerchantId: subDetails?.submerchantId || "",
                    bankDetails: primaryBank ? [primaryBank] : (foundRecord?.bankDetails || null)
                };
            }));

            const isApproved = lawyerFilter?.activeTab === "APPROVED";
            const fileName = `Advocate_${isApproved ? "Approved" : "Rejected"}_Report_${dayjs().format("YYYY-MM-DD_HH-mm")}`;
            exportAdvocateReportToExcel(
                recordsToExport,
                fileName,
                isApproved ? "APPROVED" : "REJECTED",
                emailDetails
            );
            setIsSubmerchantModalOpen(false);
            showSuccessNotification("Success", emailDetails?.toEmail ? "Advocate report downloaded and email composer opened successfully." : "Advocate report downloaded successfully.");
        } catch (error) {
            console.error("Failed to export lawyer report:", error);
            showErrorNotification("Error", "Failed to download advocate report. Please try again.");
        } finally {
            dispatch(loaderReducer(false));
        }
    };

    const handleRequestLabel = () => {
        setShowCheckbox(true);
    };

    const handleCancelRequestLabel = () => {
        setShowCheckbox(false);
        setSelectedLawyerIds([]);
        setSelectedLawyerRecords([]);
    };

    const visibleIds = (lawyerData || []).map(item => item?.lawyerId || item?.id).filter(Boolean);
    const isAllSelected = visibleIds.length > 0 && visibleIds.every(id => selectedLawyerIds.includes(id));
    const isIndeterminate = visibleIds.some(id => selectedLawyerIds.includes(id)) && !isAllSelected;

    const handleDocumentClose = () => {
        setLawyerBooleans(prev => ({ ...prev, isDocumentOpen: false, isgetLawyer: false }));
        setLawyerFilter(prev => ({ ...prev, active: 0 }));
    };

    const handleViewDocument = (detail, position) => {
        setLawyerFilter(prev => ({ ...prev, active: position, documentFile: detail }));
    };

    const handleMonthChange = (month, type) => {
        const monthValue = dayjs(month).format("YYYY-MM");
        if (type === "lawyer") {
            if (month) {
                setLawyerFilter(prev => ({ ...prev, month: month, monthString: monthValue, fromDate: "", toDate: "" }));
            }
            else {
                setLawyerFilter(prev => ({ ...prev, month: null, monthString: "" }));
            }
        }
        else if (type === "consultation") {
            if (month) {
                setConsultation(prev => ({ ...prev, month: month, monthString: monthValue, fromDate: "", toDate: "" }));
            }
            else {
                setConsultation(prev => ({ ...prev, month: null, monthString: "" }));
            }
        }
        else if (type === "complaints") {
            if (month) {
                setComplaintFilters(prev => ({ ...prev, month: month, monthString: monthValue, fromDate: "", toDate: "" }));
            }
            else {
                setComplaintFilters(prev => ({ ...prev, month: null, monthString: "" }));
            }
        }
    };

    const handleProfileModelOpen = () => {
        setLawyerBooleans(prev => ({ ...prev, profileModelOpen: true }));
    };

    const handleProfileModelClose = () => {
        setLawyerBooleans(prev => ({ ...prev, profileModelOpen: false }));
    };

    const handleConsultationClose = () => {
        setConsultationBooleans(prev => ({ ...prev, isconsultationDrawerOpen: false }));
    };

    const handlComplaintsDetailClose = () => {
        setConsultationBooleans(prev => ({ ...prev, isComplaintDrawerOpen: false, isDownloadButtonEnable: false }));
    };

    const handleConsultationReport = () => {
        setConsultationBooleans(prev => ({ ...prev, isConsultationReportOpen: true }));
    };

    const handleSendMessage = (messageType, list) => {
        setConsultationBooleans(prev => ({ ...prev, isSendMessage: messageType === "sendMessage", isSendWarningMessage: messageType === "sendWarningMessage" }));
        setMessageData(prev => ({
            ...prev, complaintType: list?.data?.complaintType,
            warning: messageType === "sendWarningMessage",
            againstById: list?.data?.againstById,
            raisedById: list?.data?.raisedById,
            complaintId: list?.data?.complaintId,
            warnedBy: adminuserId,
        }));
    };

    const handleSendMessageClose = () => {
        setConsultationBooleans(prev => ({ ...prev, isSendMessage: false, isSendWarningMessage: false }));
        setMessageData(prev => ({ ...prev, activeTab: "raised", activeTabKey: "1", isMail: true, isWhatsapp: false, body: "", subject: "" }));
    };

    const handleSubmitMessage = () => {
        const basePayload = {
            ...(messageData?.activeTab === "against" ? { againstById: messageData?.againstById } : {}),
            ...(messageData?.activeTab === "raised" ? { raisedById: messageData?.raisedById } : {}),
            complaintType: messageData?.complaintType,
            subject: messageData?.subject,
            body: messageData?.body,
            warning: messageData?.warning,
            complaintId: messageData?.complaintId,
            warnedBy: messageData?.warnedBy
        }
        if (messageData?.isWhatsapp && messageData?.isMail) {
            const warnedInArray = ["WHATSAPP", "EMAIL"];
            queryClient.prefetchQuery(["SEND_MESSAGE_WHATSAPP", ""], () => sendWhatsAppMessage({ ...basePayload, warnedIn: warnedInArray }));
            queryClient.prefetchQuery(["SEND_MESSAGE_MAIL", ""], () => sendMailMessage({ ...basePayload, warnedIn: warnedInArray }));
        }
        else if (messageData?.isWhatsapp) {
            queryClient.prefetchQuery(["SEND_MESSAGE_WHATSAPP", ""], () => sendWhatsAppMessage({ ...basePayload, warnedIn: ["WHATSAPP"] }));
        }
        else if (messageData?.isMail) {
            queryClient.prefetchQuery(["SEND_MESSAGE_MAIL", ""], () => sendMailMessage({ ...basePayload, warnedIn: ["EMAIL"] }));
        }
    };

    const handleSupportSendMessage = () => {
        const selectedPlatforms = supportMessage?.platforms || [];
        const basePayload = {
            body: supportMessage?.message,
            supportId: supportIdData?.data?.supportId || "",
            complaintType: supportIdData?.data?.complaintType || "",
            userId: supportIdData?.data?.userId || "",
            subject: supportMessage?.subject,
            actionItemTakenById: adminuserId
        }
        if (selectedPlatforms?.includes("whatsapp")) {
            queryClient.prefetchQuery(["SEND_MESSAGE_WHATSAPP_SUPPORT", ""], () => sendWhatsAppSupportMessage({ ...basePayload, supportedIn: 'WHATSAPP' }));
        }
        if (selectedPlatforms?.includes("email")) {
            queryClient.prefetchQuery(["SEND_MESSAGE_MAIL_SUPPORT", ""], () => sendMailSupportMessage({ ...basePayload, supportedIn: 'EMAIL' }));
        }
    };

    const handleMessageTabChange = (key) => {
        messageTabData?.forEach((tab) => {
            if (tab?.key === key) {
                const { content } = tab || {};
                setMessageData(prev => ({ ...prev, activeTab: content }));
            }
            setMessageData(prev => ({ ...prev, activeTabKey: key }));
            setMessageData(prev => ({ ...prev, body: "", subject: "", isWhatsapp: false, isMail: true }));
        });
    };

    const handleMessageCheck = (check, type) => {
        if (type === "whatsapp") {
            setMessageData(prev => ({ ...prev, isWhatsapp: check }));
        }
        else if (type === "mail") {
            setMessageData(prev => ({ ...prev, isMail: check }));
        }
        else if (type === "warning") {
            setMessageData(prev => ({ ...prev, warning: check }));
        }
    };

    const handleMessageChange = (fieldValue, fieldName) => {
        setMessageData(prev => ({ ...prev, [fieldName]: fieldValue }));
    };

    const handleComplaintStatus = (status) => {
        if (status) {
            setComplaintFilters(prev => ({ ...prev, complaintStatus: status }));
        }
        else {
            setComplaintFilters(prev => ({ ...prev, complaintStatus: "" }));
        }
    };

    const handleConsultationComplaintReportOpen = () => {
        setComplaintFilters(prev => ({ ...prev, isComplaintReportOpen: true }));
    };

    const handleAllComplaintReport = () => {
        setComplaintFilters(prev => ({ ...prev, isAllComplaintReportOpen: true, size: -1 }));
    };


    const handleActiveChange = (fieldValue, fieldName) => {
        setLawyerFilter(prev => ({ ...prev, [fieldName]: fieldValue }));
    };

    const handleActivationSubmit = (type) => {
        if (type === "hold") {
            const hasBlockDays = Boolean(lawyerFilter?.blockDays);
            const hasReason = Boolean(lawyerFilter?.reason?.trim());
            if (!hasBlockDays || !hasReason) {
                showErrorNotification("Error", "No of days to Block and Reason are required.");
                return;
            }
        }
        const payload = {
            reason: lawyerFilter?.reason,
            blockDays: Number(lawyerFilter?.blockDays),
            blockDate: dayjs().format('YYYY-MM-DD')
        }
        if (type === "active") {
            queryClient.prefetchQuery(["ACTIVATE_LAWYER", ""], () => activeLawyer(lawyerFilter?.lawyerId));
        }
        else if (type === "hold") {
            queryClient.prefetchQuery(["HOLD_LAWYER", ""], () => holdlawyer(lawyerFilter?.lawyerId, payload));
        }
    };

    const handleActiveClose = () => {
        setLawyerBooleans(prev => ({ ...prev, openInactiveModel: false }));
        setLawyerFilter(prev => ({ ...prev, reason: "", blockDays: "" }));
    };

    const handleEditHistoryClose = () => {
        setLawyerBooleans(prev => ({ ...prev, isEditHistoryOpen: false }));
        setEditHistoryState(initialEditHistoryState);
    };

    const handleViewEditHistory = (historyDetail) => {
        setEditHistoryState(prev => ({ ...prev, selectedHistoryDetail: historyDetail }));
    };

    const handleEditHistoryModalClose = () => {
        setEditHistoryState(prev => ({ ...prev, selectedHistoryDetail: null }));
    };

    useEffect(() => {
        if (lawyerFilter?.isReportOpen) {
            handlePrint()
        }
    }, [lawyerFilter?.isReportOpen, handlePrint]);

    useEffect(() => {
        if (complaintsFilter?.isComplaintReportOpen) {
            handleComplaintReportPrint();
        }
    }, [complaintsFilter?.isComplaintReportOpen, handleComplaintReportPrint]);

    useEffect(() => {
        if (complaintsFilter?.isAllComplaintReportOpen) {
            handleAllComplaintReportPrint();
        }
    }, [complaintsFilter?.isAllComplaintReportOpen, handleAllComplaintReportPrint]);

    useEffect(() => {
        const isMail = messageData?.isMail ?? true;
        const isButtonEnable = Boolean(messageData?.subject && messageData?.body && (messageData?.isWhatsapp || isMail));
        if (messageData?.isButtonEnable !== isButtonEnable) {
            setMessageData(prev => ({ ...prev, isButtonEnable: isButtonEnable }));
        }
    }, [messageData?.subject, messageData?.body, messageData?.isWhatsapp, messageData?.isMail, messageData?.isButtonEnable]);

    useEffect(() => {
        const isLoading = isFetchingAllLawyerDetails || isFetchinglawyerById || isFetchingLawyerConsultationById || isFetchingConsultationById || isFetchingComplaintById || isFetchingLawyerComplaints || isFetchingSendMessage || isFetchingSenfMailMessage || isFetchingHoldLawyer || isFetchingActivelawyer || isFetchingSupportById || isFetchingSendSupportWhatsApp || isFetchingSendSupportMail || isFetchingAccountDetails || isFetchingDecryptAccount;
        dispatch(loaderReducer(isLoading));
    }, [dispatch, isFetchingAllLawyerDetails, isFetchinglawyerById, isFetchingLawyerConsultationById, isFetchingConsultationById, isFetchingComplaintById, isFetchingLawyerComplaints, isFetchingSendMessage, isFetchingSenfMailMessage, isFetchingHoldLawyer, isFetchingActivelawyer, isFetchingSupportById, isFetchingSendSupportWhatsApp, isFetchingSendSupportMail, isFetchingAccountDetails, isFetchingDecryptAccount]);

    return <>
        <div>
            {(!complaintsFilter?.openComplaints && !consultation?.openConsultation) && <>
                <div className="flexible">
                    <h6 style={{ padding: "10px", margin: 0 }}>Advocate Management</h6>
                    <div className="flexible">
                        {lawyerFilter?.activeTab === "APPROVED" && (<UiSelect allowClear={false} options={activeStatus} name="userStatus" style={{ width: "120px" }} onChange={(field) => handleActiveInactiveFilter(field)} value={lawyerFilter?.userStatus} />)}
                        <DatePicker picker="month" format="MMM" value={lawyerFilter?.month || null} onChange={(month) => handleMonthChange(month, "lawyer")} style={{ height: 32, width: 150, borderRadius: 6 }} disabledDate={(current) => current && current > dayjs().endOf("day")} />
                        <UiRangePicker value={lawyerFilter?.fromDate && lawyerFilter?.toDate ? [dayjs(lawyerFilter?.fromDate), dayjs(lawyerFilter?.toDate)] : null} onChange={(date) => handleDateChange(date, "lawyer")} disabledDate={(current) => current && current > dayjs().endOf("day")} />
                        <UiSearch placeholder={keywords?.searchPlaceholder} onChange={(search) => handleSearch(search.target.value, "lawyer")} value={lawyerFilter?.searchFilter} />
                    </div>
                </div>
                <div className="flexible-end" style={{ padding: "4px 8px 10px 8px" }}>
                    {!showCheckbox ? (
                        <UiButton
                            type="primary"
                            onClick={handleRequestLabel}
                        >
                            Request Label
                        </UiButton>
                    ) : (
                        <UiButton
                            onClick={handleCancelRequestLabel}
                        >
                            Cancel
                        </UiButton>
                    )}
                    <UiButton
                        type="primary"
                        disabled={selectedLawyerIds?.length === 0}
                        onClick={handleOpenExcelModal}
                    >
                        <img src={downloadReport} alt="" />Download Report in Excel
                    </UiButton>
                    <UiButton type="primary" onClick={handleReportPrint} style={{ borderRadius: "4px" }}>
                        <img src={downloadReport} alt="" />Download Report
                    </UiButton>
                </div>
                <>
                    <UiTab tabs={tabData} onChange={handleTabChanges} activeTabKey={lawyerFilter?.activeTabKey} count={lawyerDetailsData?.result?.lawyerDetails?.totalElements || 0} />
                    <UiTable
                        dataSource={lawyerData}
                        columns={lawyerFilter?.activeTab === "APPROVED" ? APPROVAL_HEADER_COLUMNS({
                            actionRender,
                            handleDocuments,
                            userStatus: lawyerFilter?.userStatus,
                            handleBankDetails,
                            selectedLawyerIds,
                            handleSelectAll,
                            isAllSelected,
                            isIndeterminate,
                            handleSelectLawyer,
                            showCheckbox
                        }) : REJECTED_HEADER_COLUMNS({
                            handleRejectedLawyers,
                            handleDocuments,
                            handleBankDetails,
                            selectedLawyerIds,
                            handleSelectAll,
                            isAllSelected,
                            isIndeterminate,
                            handleSelectLawyer,
                            showCheckbox
                        })}
                        onRow={(lawyerDetail) => ({
                            onClick: () => handleLawyerRowClick(lawyerDetail)
                        })}
                        scroll={{ y: "calc(100vh - 280px)" }}
                        pagination={lawyerFilter?.isReportOpen || (lawyerDetailsData?.result?.lawyerDetails?.totalElements || 0) <= 10 ? false : {
                            pageSize: lawyerFilter?.size,
                            current: lawyerFilter?.page + 1,
                            pageSizeOptions: tablePageSizeOptions,
                            showSizeChanger: true,
                            onChange: (page, size) => handlePagination(page, size, "lawyer")
                        }}
                    />
                </>
                {lawyerBooleans?.openProfileView && (<ProfileView
                    lawyerBooleans={lawyerBooleans}
                    lawyerFilter={lawyerFilter}
                    handleProfileCancel={handleProfileCancel}
                    lawyerProfileData={lawyerProfileData}
                    handleProfileModelOpen={handleProfileModelOpen}
                    handleProfileModelClose={handleProfileModelClose}
                    agreementMd={agreementMd}
                />)}
            </>}
            {
                complaintsFilter?.openComplaints && (<Complaints
                    handleDateChange={handleDateChange}
                    handlePagination={handlePagination}
                    complaintActionRender={complaintActionRender}
                    handleComplaintTabChange={handleComplaintTabChange}
                    complaintsFilter={complaintsFilter}
                    handleComplaintsCancel={handleComplaintsCancel}
                    handleSearch={handleSearch}
                    handleMonthChange={handleMonthChange}
                    handleComplaintStatus={handleComplaintStatus}
                    complaintsResponseData={complaintsResponseData}
                    allComplaints={allComplaints}
                    handleAllComplaintReport={handleAllComplaintReport}
                    handleComplaintAction={handleComplaintAction} />)}
            {
                consultation?.openConsultation && (<Consultation
                    handleDateChange={handleDateChange}
                    handlePagination={handlePagination}
                    handleConsultationCancel={handleConsultationCancel}
                    handleConsultationTabChange={handleConsultationTabChange}
                    consultationData={consultationData}
                    allConsultationData={allConsultationData}
                    consultation={consultation}
                    consultationRef={consultationRef}
                    consultationActionRender={consultationActionRender}
                    handleSearch={handleSearch}
                    handleMonthChange={handleMonthChange}
                    handleConsultationReport={handleConsultationReport}
                    setConsultation={setConsultation}
                    setConsultationBooleans={setConsultationBooleans}
                    getConsultationDropdown={getConsultationDropdown} />)}
            {
                lawyerBooleans?.isEditHistoryOpen && <EditHistory
                    isOpen={lawyerBooleans?.isEditHistoryOpen}
                    handleEditHistoryClose={handleEditHistoryClose}
                    editHistoryData={editHistoryState?.editHistoryData}
                    selectedLawyerName={editHistoryState?.selectedLawyerName}
                    selectedLawyerProfile={editHistoryState?.selectedLawyerProfile}
                    editHistoryColumns={EDIT_HISTORY_COLUMNS({ handleViewEditHistory })}
                    selectedHistoryDetail={editHistoryState?.selectedHistoryDetail}
                    editableRequestFields={LAWYER_EDITABLE_FIELDS}
                    handleEditHistoryModalClose={handleEditHistoryModalClose}
                />
            }
            {
                consultationBooleans?.isconsultationDrawerOpen && <ConsultationView
                    consultation={consultation}
                    consultationBooleans={consultationBooleans}
                    consultationIdData={consultationIdData}
                    handleConsultationClose={handleConsultationClose} />}
            {
                consultationBooleans?.isComplaintDrawerOpen && <ComplaintView
                    consultationBooleans={consultationBooleans}
                    handlComplaintsDetailClose={handlComplaintsDetailClose}
                    handleSendMessage={handleSendMessage}
                    handleSendMessageClose={handleSendMessageClose}
                    complaintIdData={complaintIdData}
                    handleConsultationComplaintReportOpen={handleConsultationComplaintReportOpen}
                    handleMessageChange={handleMessageChange}
                    handleMessageTabChange={handleMessageTabChange}
                    messageData={messageData}
                    handleMessageCheck={handleMessageCheck}
                    handleSubmitMessage={handleSubmitMessage}
                    isButtonLoading={isFetchingSendMessage || isFetchingSenfMailMessage}
                />}
            {
                consultationBooleans?.isSupportDrawerOpen && <SupportDrawer
                    openProfileView={consultationBooleans?.isSupportDrawerOpen}
                    handleProfileCancel={() => setConsultationBooleans(prev => ({ ...prev, isSupportDrawerOpen: false }))}
                    supportProfileData={{
                        ...supportIdData?.data,
                        name: supportIdData?.data?.raisedByName,
                        mobileNumber: supportIdData?.data?.raisedByMobileNumber,
                        email: supportIdData?.data?.raisedByEmail,
                        profilePic: supportIdData?.profileUrl
                    }}
                    activeTab={"LAWYERS"}
                    selectedPlatforms={supportMessage?.platforms}
                    setSelectedPlatforms={(val) => setSupportMessage(prev => ({ ...prev, platforms: val }))}
                    subject={supportMessage?.subject}
                    setSubject={(val) => setSupportMessage(prev => ({ ...prev, subject: val }))}
                    message={supportMessage?.message}
                    setMessage={(val) => setSupportMessage(prev => ({ ...prev, message: val }))}
                    handleSendMessage={handleSupportSendMessage}
                />
            }
            {
                lawyerBooleans?.isDocumentOpen && (<LawyerDocuments
                    lawyerBooleans={lawyerBooleans}
                    lawyerFilter={lawyerFilter}
                    handleDocumentClose={handleDocumentClose}
                    documentData={documentData}
                    handleViewDocument={handleViewDocument}
                    loading={isFetchingLawyerDocuments} />)}
            <BankDetailsModal
                open={bankDetailsModal?.open}
                onClose={handleBankDetailsClose}
                bankDetails={bankDetailsModal?.data}
                loading={bankDetailsModal?.loading}
            />
            <Modal
                closable={false}
                open={lawyerBooleans?.openInactiveModel}
                footer={<div className="flexible-end">
                    <UiButton onClick={handleActiveClose}>No</UiButton>
                    <UiButton
                        disabled={!(lawyerFilter?.userStatus === "INACTIVE" || lawyerFilter?.userStatus === "HOLD") && (!lawyerFilter?.blockDays || !lawyerFilter?.reason?.trim())}
                        onClick={() => handleActivationSubmit(lawyerFilter?.userStatus === "INACTIVE" || lawyerFilter?.userStatus === "HOLD" ? "active" : "hold")}
                        style={{ backgroundColor: "#F1C40F", color: "#fff" }}
                    >
                        Yes
                    </UiButton>
                </div>}
            >{
                    lawyerFilter?.userStatus === "INACTIVE" || lawyerFilter?.userStatus === "HOLD" ? <div>
                        <div className="inactive-model">
                            <img src={warningIcon} alt="" />
                            <p>Are you sure you want to make this Advocate Active ?</p>
                        </div>
                    </div> : <div>
                        <div className="inactive-model">
                            <img src={warningIcon} alt="" />
                            <p>Are you sure you want to Hold this Advocate ?</p>
                        </div>
                        <div>
                            <label style={{ padding: "0px 10px", marginBottom: "10px" }}>No of days to Block <span style={{ color: "red" }}>*</span></label>
                            <UiSelect style={{ width: "100%", padding: "0px 10px" }} options={blockDaysOption} required value={lawyerFilter?.blockDays || null} name="blockDays" onChange={(days) => handleActiveChange(days, "blockDays")} placeholder={"Select Days"} />
                            <UiTextArea value={lawyerFilter?.reason} label={"Reason"} required name="reason" onChange={(field) => handleActiveChange(field?.target?.value, "reason")} placeholder={"Reason..."} />
                        </div>
                    </div>
                }
            </Modal>
            <div style={{ display: "none" }}>
                <PrintAllLawyerReport ref={reportRef} data={lawyerData} fromDate={lawyerFilter?.fromDate} toDate={lawyerFilter?.toDate} activeTab={lawyerFilter?.activeTab} selectedMonth={lawyerFilter?.month} selectedMonthString={lawyerFilter?.monthString} />
            </div>
            <div style={{ display: "none" }}>
                <PrintSingleComplaintreport ref={singlcomplaintRef} complaintIdData={complaintIdData} />
            </div>
            <div style={{ display: "none" }}>
                <PrintComplaintReport ref={complaintRef} data={complaintsResponseData} fromDate={complaintsFilter?.fromDate} toDate={complaintsFilter?.toDate} complaintStatus={complaintsFilter?.complaintStatus} selectedMonth={complaintsFilter?.month} selectedMonthString={complaintsFilter?.monthString} />
            </div>
            <div style={{ display: "none" }}>
                <PrintConsultationReport ref={consultationRef} data={consultationData} activeTab={consultation?.activeTab} allConsultationData={allConsultationData} consultation={consultation} selectedMonth={consultation?.month} selectedMonthString={consultation?.monthString} />
            </div>
            <SubmerchantModal
                open={isSubmerchantModalOpen}
                onClose={() => setIsSubmerchantModalOpen(false)}
                onConfirm={handleDownloadExcelReport}
                selectedRecords={selectedLawyerIds.map(id => {
                    return selectedLawyerRecords.find(item => (item?.lawyerId || item?.id) === id)
                        || lawyerData.find(item => (item?.lawyerId || item?.id) === id)
                        || { id, lawyerId: id };
                })}
                toEmailAddress={toemailaddress}
                ccEmailAddress={ccemailaddress}
            />
        </div>
    </>
};
export default Lawyer